export const CONFERENCE = '/conference/' as const
export const CONFERENCE_ALL = `${CONFERENCE}all` as const
export const CONFERENCE_ALL_FILTER = `${CONFERENCE_ALL}/filter` as const
export const CONFERENCE_CATEGORY_ALL = `${CONFERENCE}category/all` as const
export const CONFERENCE_ARTICLE_LIST = '/conference/article' as const
export const CONFERENCE_ARTICLE = `${CONFERENCE}article/` as const
export const CONFERENCE_ARTICLE_ALL = `${CONFERENCE}article/all` as const
export const CONFERENCE_MAGAZINE_ARTICLE = `${CONFERENCE}magazine/article` as const
export const CONFERENCE_ARTICLE_STEP = `${CONFERENCE}article/step` as const
export const CONFERENCE_ARTICLE_PROOF = `${CONFERENCE}article/proof` as const
